import { Globe } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const OPTIONS: Array<{ code: 'en' | 'es'; labelKey: string }> = [
  { code: 'en', labelKey: 'language.english' },
  { code: 'es', labelKey: 'language.spanish' },
]

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation('common')
  // Normalize: i18next may report `es-MX` or `es-ES` even with just `es`
  // registered; render the "es" option whenever the language starts with "es".
  const current: 'en' | 'es' = i18n.language?.toLowerCase().startsWith('es')
    ? 'es'
    : 'en'

  return (
    <label className="flex items-center gap-2 px-3 py-2 text-xs text-text-secondary">
      <Globe className="h-4 w-4" />
      <span className="sr-only">{t('language.label')}</span>
      <select
        value={current}
        onChange={(e) => {
          const next = e.target.value
          if (next === current) return
          void i18n.changeLanguage(next).finally(() => {
            // TODO(i18n): replace this hard reload with a soft re-render once
            // the React 19 + StrictMode interaction with `useTranslation` is
            // fixed. Today, calling `i18n.changeLanguage()` updates the
            // i18next store but components don't always rerender — the bound
            // `t()` references captured during the first render keep
            // returning the previous language until the tree remounts.
            // Reproduces only under React 19 StrictMode; downgrading or
            // disabling StrictMode hides it. The reload sidesteps the issue
            // by remounting from scratch with the new language already
            // committed to localStorage. See:
            //   https://github.com/i18next/react-i18next/issues/1771
            window.location.reload()
          })
        }}
        className="flex-1 rounded-md border border-border bg-surface px-2 py-1 text-xs text-text-primary focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
      >
        {OPTIONS.map((opt) => (
          <option key={opt.code} value={opt.code}>
            {t(opt.labelKey)}
          </option>
        ))}
      </select>
    </label>
  )
}
